import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { subscriptionAPI } from '../services/api';
import './SubscriptionBanner.scss';

/**
 * SubscriptionBanner
 * - Shows when days_remaining <= 30 (status: active/grace) or status is expired/suspended
 * - Not dismissible — stays visible until subscription is renewed
 */
export default function SubscriptionBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    subscriptionAPI.getStatus()
      .then((res) => {
        const data = res.data?.data;
        if (!data) return;

        const { status, days_remaining } = data;
        const shouldShow =
          status === 'expired' ||
          status === 'suspended' ||
          (status === 'grace') ||
          (status === 'active' && days_remaining !== null && days_remaining <= 30);

        if (shouldShow) {
          setInfo(data);
        }
      })
      .catch(() => { /* non-critical */ });
  }, []);

  if (!info) return null;

  const { status, days_remaining, grace_until } = info;

  let bannerClass = 'sub-banner sub-banner--warning';
  let message = '';

  if (status === 'expired') {
    bannerClass = 'sub-banner sub-banner--danger';
    message = 'EXPIRED — Your subscription has expired. Please renew to restore full access.';
  } else if (status === 'grace') {
    const graceDate = grace_until
      ? new Date(grace_until).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
      : '';
    bannerClass = 'sub-banner sub-banner--danger';
    message = `GRACE PERIOD — Expires ${graceDate}. Renew immediately to avoid service interruption.`;
  } else if (status === 'suspended') {
    bannerClass = 'sub-banner sub-banner--danger';
    message = 'SUSPENDED — Your account has been suspended. Contact your administrator.';
  } else {
    // active, days_remaining <= 30
    message = `Your subscription expires in ${days_remaining} day${days_remaining !== 1 ? 's' : ''}. Renew now to avoid disruption.`;
  }

  return (
    <div className={bannerClass} role="alert">
      <span className="sub-banner__message">{message}</span>
      <div className="sub-banner__actions">
        <Link to="/subscription" className="sub-banner__renew-link">Renew Now</Link>
      </div>
    </div>
  );
}
